module.exports = __webpack_public_path__ + "Release.dd22b333deab447e458f724939632b26.hashedasset.svg";